import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function parallax() {
  const elements = document.querySelectorAll('[data-animation="parallax"]')

  if (window.innerWidth > 1024) {
    if (elements.length > 0) {
      elements.forEach((element) => {
        const distance = element.getAttribute('data-distance')

        gsap.to(element, {
          y: distance,
          ease: 'none',
          scrollTrigger: {
            start: 'top top',
            end: 'bottom top',
            scrub: true,
          },
        })
      })
    }
  }
}

export default parallax
